import { useEffect } from "react";
import { useSiteConfig } from "@/hooks/useSiteConfig";

const FaviconUpdater = () => {
  const { siteConfig } = useSiteConfig();

  useEffect(() => {
    if (siteConfig?.favicon_url) {
      // Remove existing favicon links
      const existingLinks = document.querySelectorAll('link[rel*="icon"]');
      existingLinks.forEach(link => link.remove());

      // Add new favicon
      const link = document.createElement('link');
      link.rel = 'icon';
      link.type = 'image/png';
      link.href = siteConfig.favicon_url;
      document.head.appendChild(link);
    }
  }, [siteConfig?.favicon_url]);

  return null;
};

export default FaviconUpdater;